// extracted by mini-css-extract-plugin
export default {"search":"Filters_search__EjyhV"};